// extracted by mini-css-extract-plugin
module.exports = {"partnersUsers":"_2pf9K"};